var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2349_22668",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8333 1.66772C17.214 1.66772 18.3333 2.78701 18.3333 4.16772V15.8344C18.3333 17.2151 17.214 18.3344 15.8333 18.3344H4.16663C2.78591 18.3344 1.66663 17.2151 1.66663 15.8344V4.16772C1.66663 2.78701 2.78591 1.66772 4.16663 1.66772H15.8333ZM16.6666 6.66772H3.33329V15.8344C3.33329 16.2946 3.70639 16.6677 4.16663 16.6677H15.8333C16.2935 16.6677 16.6666 16.2946 16.6666 15.8344V6.66772ZM10.0973 14.9955L10 15.0011L9.92996 14.9977L9.83277 14.9842L9.73992 14.9596L9.64735 14.923L9.56611 14.8794L9.50406 14.8375L9.41077 14.757L6.91071 12.257C6.58526 11.9315 6.58526 11.4039 6.91071 11.0785C7.21112 10.7781 7.68383 10.755 8.01074 11.0091L8.08925 11.0785L9.16663 12.1552L9.16669 9.16772C9.16669 8.74036 9.48839 8.38813 9.90284 8.34L10.0001 8.33439C10.4603 8.33439 10.8334 8.70749 10.8334 9.16772L10.8333 12.1552L11.9108 11.0785C12.2113 10.7781 12.684 10.755 13.0109 11.0091L13.0894 11.0785C13.3898 11.3789 13.4129 11.8516 13.1587 12.1785L13.0894 12.257L10.5893 14.757L10.5181 14.8206L10.4599 14.8628L10.3783 14.9105L10.2834 14.9517L10.2217 14.9712L10.0973 14.9955ZM15.8333 3.33439H4.16663C3.70639 3.33439 3.33329 3.70749 3.33329 4.16772V5.00106H16.6666V4.16772C16.6666 3.70749 16.2935 3.33439 15.8333 3.33439Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2349_22668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000976562H20V20.001H0V0.000976562Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archiveIcon.a67eaac8.svg";
export { ForwardRef as ReactComponent };